import React from "react";
import "../index.css";

function Navbar() {
  return (
    <nav className="navbar">
      <div className="navbar-logo"></div>
      <ul className="navbar-menu">
        {["vision", "about us", "products", "charities", "contact"].map(id => (
          <li key={id}>
            <a href={`#${id}`}>
              {id.replace(/^\w/, c => c.toUpperCase())}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}

export default Navbar;
